import CustomSentenceWorkspace from '../component/CustomSentenceWorkspace';

/** Keep the original /sentence route and its optional Pinyin toggle. */
export default function CustomSentence() {
    return <CustomSentenceWorkspace />;
}
